import { EntitlementsProject } from '@adsk/alloy-provider';

import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

const isToolAllowed = (
  currentProject: EntitlementsProject | undefined,
  toolId: string,
  productId: string | undefined,
) => {
  if (productId) {
    const product = currentProject?.products.find((p) => p.key === productId);
    return product?.tools?.some(
      (tool) => tool.key === toolId && tool.authorized !== false,
    );
  } else {
    return currentProject?.products.some((product) =>
      product?.tools?.some(
        (tool) => tool.key === toolId && tool.authorized !== false,
      ),
    );
  }
};

/**
 * Checks whether plugin can be used in picker according to plugin and current project.
 * @param plugin
 * @param currentProject
 * @param bypassToolIds - list of toolIds that will be ignored
 * @return {boolean}
 */
export const isPluginProductOrToolNotAvailableInEntitlements = ({
  plugin,
  currentProject,
  bypassToolIds,
}: {
  plugin?: CommonReferencePickerPlugin | null;
  currentProject: EntitlementsProject | undefined;
  bypassToolIds?: string[];
}) => {
  if (
    bypassToolIds &&
    plugin?.toolId &&
    bypassToolIds?.includes(plugin?.toolId)
  ) {
    return false;
  }

  const productAllowed =
    !plugin?.productId ||
    currentProject?.products.some(
      (product) =>
        product.key === plugin.productId && product.authorized !== false,
    );

  const toolAllowed =
    !plugin?.toolId ||
    isToolAllowed(currentProject, plugin.toolId, plugin?.productId);

  return !productAllowed || !toolAllowed;
};
